export default {
    html: {
        scrollBehavior: 'smooth',
    },
    '*, *::before, *::after': {
        margin: 0,
        padding: 0,
    },
    'a, a:link, a:visited': {
        textDecoration: 'none',
    },
};
